  <div *ngIf="isActionModalShown" id="SubscribeBoxModal" class="modal fade success-popup" tabindex="-1" role="dialog" [config]="{ show: true }" (onHidden)="onHidden()" bsModal #autoShownModal="bs-modal">
    <div class="custom-theme-modal modal-dialog modal-md modal-dialog-centered">
     <div class="modal-content">
       <div class="modal-header d-block text-right pt-3 pb-2" *ngIf="isActionModalHeaderShown">
        <span (click)="hideModal()"  class="cursor-pointer">
        <img src="assets/themes/icons/cancel.svg" alt="cross">  
        </span>
  
       </div>
           <div class="modal-body p-3 mt-3 text-center">
               <div>
               <span class="heading-3">{{title}}</span>
               <br>
               <span class="paragraph" >
               <span class="color-grey-700"  innerHTML="{{description}}" ></span></span>
               </div>
           </div>
           <div class="modal-footer d-block text-center btn-list">
            <ng-container class="" *ngFor="let process of actionData.process">
               <button [ngClass]="process?.class?process?.class:'btn-design outline small'" *ngIf="process.type=='button' " type="button" (click)="actionModal(process.target)">
                 <div *ngFor="let prms of process.param"><label class="m-0" *ngIf="prms.key=='label'" >{{prms.value}}</label></div>
               </button>
           </ng-container>
           </div>
        </div>
   </div>
  </div>